import { deClientPortalAppraiserSelectionSection } from './ValuationPlausibility/AppraiserSelectionSection'
import { deClientPortalApprovalModal } from './ValuationPlausibility/ApprovalModal'
import { deClientPortalHandoverApprovalSection } from './ValuationPlausibility/HandoverApprovalSection'
import { deClientPortalHandoverApprovalStatusActions } from './ValuationPlausibility/HandoverApprovalStatusActions'
import { deClientPortalHandoverModal } from './ValuationPlausibility/HandoverModal'
import { deClientPortalValuationPlausibilityHeaderBar } from './ValuationPlausibility/HeaderBar'
import { deClientPortalInternalApprovalModal } from './ValuationPlausibility/InternalApprovalModal'
import { deClientPortalPlausibilityAnnotations } from './ValuationPlausibility/PlausibilityAnnotations'
import { deClientPortalPlausibilityPdf } from './ValuationPlausibility/PlausibilityPdf'
import { deClientPortalValuationPlausibilityPage } from './ValuationPlausibility/ValuationPlausibility'

export const deClientPortalValuationPlausibility = {
    valuationPlausibility: deClientPortalValuationPlausibilityPage,
    headerBar: deClientPortalValuationPlausibilityHeaderBar,
    handoverApprovalSection: deClientPortalHandoverApprovalSection,
    handoverApprovalStatusActions: deClientPortalHandoverApprovalStatusActions,
    handoverModal: deClientPortalHandoverModal,
    approvalModal: deClientPortalApprovalModal,
    internalApprovalModal: deClientPortalInternalApprovalModal,
    appraiserSelectionSection: deClientPortalAppraiserSelectionSection,
    plausibilityAnnotations: deClientPortalPlausibilityAnnotations,
    plausibilityPdf: deClientPortalPlausibilityPdf,
}
